import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { AdSlot } from '../ads/AdSlot';
interface LayoutProps {
  children: React.ReactNode;
  onNavigate: (page: string) => void;
  currentPage: string;
}
export function Layout({
  children,
  onNavigate,
  currentPage
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-slate-50 relative pb-[50px] sm:pb-0" data-id="element-14167">
      <Header onNavigate={onNavigate} currentPage={currentPage} data-id="element-14168" />
      <main className="flex-grow flex flex-col" data-id="element-14169">{children}</main>
      <Footer onNavigate={onNavigate} data-id="element-14170" />
      <AdSlot slotId="SLOT-18" onNavigate={onNavigate} data-id="element-14171" />
    </div>;
}